import { StandingAccessReportEntitlementFragmentFragment } from '@api/gql/graphql';
import { Table as MuiTable, TableRow, TableCell, TableBody } from '@mui/material';
import { TableWrapper } from '@components/TableWrapper';
import { RiskScoreItem } from '@common/components/RiskScore';
import { getFragmentData } from '@api/gql/fragment-masking';
import {
  standingAccessReportPermissionFragmentDocument,
  standingAccessReportResourceFragmentDocument,
} from '@StandingAccess/services/gql';
import PrimarySecondary from '@common/ui/PrimarySecondary';

export default function AssessmentReportDrawerGroupInfo({
  entitlementGroup,
}: {
  entitlementGroup: StandingAccessReportEntitlementFragmentFragment;
}) {
  const permission = getFragmentData(standingAccessReportPermissionFragmentDocument, entitlementGroup.permission);
  const resource = getFragmentData(standingAccessReportResourceFragmentDocument, entitlementGroup.resource);

  return (
    <TableWrapper>
      <MuiTable>
        <TableBody>
          <TableRow>
            <TableCell component="th" size="medium">
              <PrimarySecondary icon={resource?.type.icons.svg} primary={resource?.name} />
            </TableCell>
            <TableCell component="th" size="medium">
              {permission?.name}
            </TableCell>
            <TableCell component="th" size="medium">
              <RiskScoreItem riskScore={entitlementGroup.riskScore} maxRiskScore={9} withRiskScore />
            </TableCell>
          </TableRow>
        </TableBody>
      </MuiTable>
    </TableWrapper>
  );
}
